import { useState } from "react";
import { FormGroup, Table, Card, CardHeader, CardFooter, CardText, CardBody, Button, Input } from 'reactstrap';
import '../GerenciamentoTurmas/GerenciamentoTurmas.css'

const NotaRegistroManual = ({ dadosRegistro, putMarcarSaida, putMarcarEntrada }) => {
    const [textoNota, setTextoNota] = useState();
    return (
        <>
            <FormGroup>
                <div className="CardConfigRegistroEntradaSaida">
                    <textarea
                        className="inputRegistroManual"
                        maxlength="150"
                        placeholder="Escreva brevemente qualquer incidência"
                        onChange={(event) => setTextoNota(event.target.value)}
                        required/>
                </div>
                <Button className="ButtonBater" onClick={() => {
                    if (dadosRegistro.tipoRegistro === "ENTRADA") {
                        putMarcarEntrada(textoNota);
                    } else {
                        putMarcarSaida(textoNota);
                    }
                }}>
                    {dadosRegistro.tipoRegistro === "ENTRADA" ? "Marcar Entrada" : "Marcar Saida" }
                </Button>
            </FormGroup>
        </>
    );
}

export default NotaRegistroManual;